import { createContext, useContext } from 'react';
import { type ApprovalContextProps } from 'modules/cbre-approvals-widget/types';

export const ApprovalContext = createContext<(ApprovalContextProps | null)>(null);
export const useApprovalsContext = () => {
  return useContext(ApprovalContext);
};